export default {
  data: ()=>({
    birthdateval: function(v) {
      if (v.length < 10) return ''
      try {
        let split = v.split('.')
        let DD = parseInt(split[0]),
            MM = parseInt(split[1]),
            YYYY = parseInt(split[2])
        let date = new Date(YYYY + 14, MM - 1, DD)
        
        if (date > new Date())
          return 'Минимальный возраст — 14 лет'
      } catch(err) {
        return 'Некорректная дата'
      }
    }
  })
}